import React, { Component } from 'react';
import styled from 'styled-components';
import { Formik } from 'formik';
import {
  Row,
  Button,
  Subtitle,
  StyledSelect,
  Label,
  Column,
} from '../../../theme/index';
import { withRouter } from 'react-router-dom';
import FindCEPic from '../../../../assets/findCE.jpg';
import Header from '../../../shared/Header';
import { getOptions } from '../../../../fixture/data';
import ImageLoader from '../../../shared/ImageLoader';

const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75%;
  @media (max-width: 780px) {
    flex-direction: column;
    width: 95%;
  }
`;

class FindCEForm extends Component {
  state = {
    profession: [{ label: 'Select a state first', value: null }],
  };
  render() {
    return (
      <ImageLoader src={FindCEPic} id="findce">
        <Header />
        {/* <Row justifycontent="flex-start" width="100%">
          <Title white margin="0 0 0 1em">
            Find your courses
          </Title>
        </Row> */}
        <Column justifycontent="center" alignitems="center">
          <Formik
            initialValues={{ state: '', profession: '' }}
            onSubmit={values => {
              let state = values.state.label.replace(/\s+/g, '-');
              let profession = values.profession.label.replace(/\s+/g, '-');
              this.props.history.push(`${profession}/${state.trim()}`);
            }}
            render={({ values, handleBlur, handleSubmit, setFieldValue }) => (
              <Form onSubmit={handleSubmit}>
                <Subtitle margin="1em .5em">Find CE for</Subtitle>
                <Row alignitems="center" style={{ position: 'relative' }}>
                  <Label htmlFor="state">
                    <StyledSelect
                      required
                      type="state"
                      id="state"
                      placeholder="State"
                      options={getOptions('state')}
                      onChange={value => {
                        setFieldValue('state', value);
                        this.setState({
                          profession: getOptions('profession', value),
                        });
                      }}
                      onBlur={handleBlur}
                      value={values.state}
                    />
                  </Label>
                  <Label htmlFor="profession">
                    <StyledSelect
                      required
                      type="profession"
                      id="profession"
                      placeholder="Profession"
                      options={this.state.profession}
                      onChange={value => {
                        setFieldValue('profession', value);
                      }}
                      onBlur={handleBlur}
                      value={values.profession}
                    />
                  </Label>
                </Row>
                <Button home type="submit">
                  Find your ce
                </Button>
              </Form>
            )}
          />
        </Column>
      </ImageLoader>
    );
  }
}

export default withRouter(FindCEForm);



// WEBPACK FOOTER //
// ./src/components/screens/FindCE/components/FindCEForm.jsx